import type { CrudResponse } from '@shared/types/crud';
import { API_BASE_URL } from '@/client/config';

/**
 * Make a request to the CRUD API via the server proxy
 * @param endpoint - The CRUD API endpoint (e.g., '/Users/swapUserAcc')
 * @param payload - The request payload
 * @param accessToken - Auth0 access token
 * @returns The CRUD API response
 */
export async function callCrudApi<T = unknown, P extends object = Record<string, unknown>>(
  endpoint: string,
  payload: P,
  accessToken: string
): Promise<CrudResponse<T>> {
  const response = await fetch(`${API_BASE_URL}/api/crud`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ endpoint, payload }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      errorData?.data?.error || `CRUD API request failed: ${response.statusText}`
    );
  }

  return response.json();
}
